export enum ETabTitularArrendatario {
  LAVRA_GARIMPEIRA = 1,
  OUTROS_REGIMES_CONFIGURACAO = 2,
  OUTROS_REGIMES_LISTAGEM = 3,
}

export interface IEstadoTitularArrendatario {
  telaSelecionada: ETabTitularArrendatario;
  paginacao?: {
    tamanhoPaginacao?: number;
    paginaSelecionada?: number;
    linkProcesso?: string;
  };
}

export default class titularArrendatarioEstadoProcesso {
  /**
   * Chave utilizada pelo navegador para lidar com o estado da tela
   */
  private static CHAVE_ESTADO = 'titularArrendatarioEstadoProcesso';

  /**
   * Limpa o estado da tela no navegador
   */
  public static limparEstado() {
    sessionStorage.removeItem(this.CHAVE_ESTADO);
  }

  /**
   * Salva o estado da tela no navegador
   *
   * @param estado Um `IEstadoTitularArrendatario` contendo o estado a ser salvo
   */
  public static salvarEstado(estado: IEstadoTitularArrendatario) {
    sessionStorage.setItem(this.CHAVE_ESTADO, JSON.stringify(estado));
  }

  /**
   * Carrega o estado da tela no navegador
   *
   * @returns Retorna um `IEstadoTitularArrendatario` ou `null` se não houver nada salvo
   */
  public static carregarEstado() {
    const jsonEstado = sessionStorage.getItem(this.CHAVE_ESTADO);

    if (jsonEstado == null) {
      return null;
    }

    return JSON.parse(jsonEstado) as IEstadoTitularArrendatario;
  }
}
